module.exports = __webpack_public_path__ + "static/media/contact-path-left.e22ff598.svg";